<template>
  <!-- Heroicon name: solid/check -->
  <svg
    v-if="value"
    class="h-5 w-5 text-green-500"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      fill-rule="evenodd"
      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
      clip-rule="evenodd"
    />
  </svg>
  <!-- Heroicon name: solid/minus -->
  <svg
    v-else
    class="h-5 w-5 text-gray-600"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      fill-rule="evenodd"
      d="M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
      clip-rule="evenodd"
    />
  </svg>
  <span class="sr-only">{{ value ? "Included" : "Not Included" }}</span>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "Check",
  setup(props) {
    return {
      ...props
    };
  },
  props: {
    value: Boolean
  }
});
</script>

<style></style>
